export default __webpack_public_path__ + "static/18_19-16fab29cc3bf2b6f4b970f4f5bab18e2.png";